<button
  appThrottleClick
  type="button"
  (throttleClick)="backClicked.emit()"
  [style.padding-bottom.rem]="paddingBottomRem"
  class="black-back-button">
  <img [src]="'assets/icons/dark/Left Chevron.svg'" alt="" />
  {{ label }}
</button>
